import apiClient from "services/apiClient";

async function addCategory(data: any) {
  const url = `/admin/categories`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addCategory;
